export default "__VITE_ASSET__CiIxU$PI__"